import { Link } from "react-router-dom";

export const CrisisFooter = ({ className = "" }) => (
  <div className={className}>
    <p data-testid="crisis-footer" className="max-w-2xl text-sm leading-relaxed text-stone-500 border-l-2 border-stone-300 pl-4">
      This is a training simulation. Scenarios are composites and the survivors are fictional.
      If you or someone you know needs help now, contact the National Domestic Violence Hotline
      at <span className="font-medium text-stone-700">1-800-799-7233</span>, or text{" "}
      <span className="font-medium text-stone-700">START to 88788</span>.
    </p>
    <p className="mt-2 pl-4 text-xs text-stone-400">
      <Link to="/sources" data-testid="sources-link" className="underline underline-offset-4 hover:text-emerald-800 transition-colors duration-150">
        Sources and Approach
      </Link>
    </p>
  </div>
);
